module.exports = __webpack_public_path__ + "img/headImg.3b063368.png";